/* CappyRoots mobile scroll fix v2 — cache-safe visual viewport compensation. */
(function () {
  var doc = document;
  var root = doc.documentElement;
  var media = window.matchMedia && window.matchMedia('(max-width: 749px)');
  var queued = false;
  var lastViewportState = null;
  var desktopStateApplied = false;

  function isMobile() {
    return !media || media.matches;
  }

  function updateViewportInsets() {
    queued = false;
    if (!isMobile()) {
      if (!desktopStateApplied) {
        root.style.removeProperty('--cr-mobile-vv-bottom');
        root.style.removeProperty('--cr-mobile-vv-height');
        root.removeAttribute('data-cr-mobile-keyboard');
        desktopStateApplied = true;
        lastViewportState = null;
      }
      return;
    }

    desktopStateApplied = false;
    var viewport = window.visualViewport;
    var windowHeight = Math.max(1, Math.round(window.innerHeight));
    var viewportHeight = viewport ? Math.max(1, Math.round(viewport.height)) : windowHeight;
    var viewportTop = viewport ? Math.round(viewport.offsetTop || 0) : 0;
    var bottomInset = Math.max(0, windowHeight - viewportTop - viewportHeight);
    var keyboardOpen = viewportHeight < windowHeight * 0.76;
    var nextViewportState = [windowHeight, viewportTop, viewportHeight, bottomInset, keyboardOpen ? 1 : 0].join(':');

    // visualViewport.scroll fires continuously while the page moves. No-op if the
    // browser chrome / keyboard geometry did not change, avoiding repeated style writes.
    if (nextViewportState === lastViewportState) return;
    lastViewportState = nextViewportState;

    root.style.setProperty('--cr-mobile-vv-bottom', bottomInset + 'px');
    // 100vh/100dvh can still include Chrome or Safari's bottom controls on real iOS devices.
    // Publish the browser's measured visible height so fixed drawers end above that UI.
    root.style.setProperty('--cr-mobile-vv-height', viewportHeight + 'px');

    if (keyboardOpen) {
      root.setAttribute('data-cr-mobile-keyboard', 'true');
    } else {
      root.removeAttribute('data-cr-mobile-keyboard');
    }
  }

  function queueUpdate() {
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(updateViewportInsets);
    }
  }

  window.addEventListener('resize', queueUpdate, { passive: true });
  window.addEventListener('orientationchange', queueUpdate, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', queueUpdate, { passive: true });
  }
  if (media && media.addEventListener) media.addEventListener('change', queueUpdate);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  else queueUpdate();
}());
